
import React      from 'react';
import CSSModules from 'react-css-modules';

import FancyCheckbox from '../FancyCheckbox';

import style from './style.scss';

class RadioOption extends React.Component {

    render() {

        return (
            <div className={this.props.className}>
                <FancyCheckbox { ...this.props } className={style['checkbox']} type="radio" />
                <label styleName="label">{ this.props.labelText }</label>
            </div>
        );
    }
}

export default CSSModules(RadioOption, style);


// WEBPACK FOOTER //
// ./components/RadioOption/index.js